import { NgModule } from '@angular/core';
import { ScheduleTipsPage } from 'pages/schedule/schedule-tips';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ScheduleTipsPage],
    imports: [PagesModule, ComponentsModule]
})
export class ScheduleTipsPageModule { }
